import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Input } from "../../../ui/input";

export const ViewUserEmail = ({ children, setEmail }: { children: React.ReactNode, setEmail: any }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const getEmail = async (password: String) => {
        const response = await fetch('__SITE_BASE__/api/me/email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ password }),
        });
        const data = await response.json();
        if(!data.success) return setPasswordError(data.message);
        setEmail(data.email);
        setIsOpen(false);
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-start justify-start">
                    <DialogTitle>
                        Enter your password to view email
                    </DialogTitle>
                <DialogDescription/>
                </DialogHeader>
                    
                <div className="flex flex-col space-y-4">

                    {passwordError && <div className="text-red-500">{passwordError}</div>}

                    <Input
                        type="password"
                        id="password"
                        className="bg-brand-back rounded border-0"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                    />
                    <div className="flex justify-end">
                        <Button
                            onClick={() => {
                                getEmail(password);
                            }}
                            
                            className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500"
                            disabled={password.length === 0}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
